import localforage from 'localforage';

/** Token 存储键名 */
const ACCESS_TOKEN_KEY = 'access_token';

/**
 * Token 管理器类（单例模式）
 * 使用 localforage 实现 Token 的持久化存储
 */
class TokenManager {
  private static instance: TokenManager;
  private storage: LocalForage;

  private constructor() {
    // 配置 localforage 实例
    this.storage = localforage.createInstance({
      name: 'acupoint-website',
      storeName: 'token_storage',
      description: 'Token storage',
    });
  }

  /**
   * 获取单例实例
   * @returns TokenManager 实例
   */
  public static getInstance(): TokenManager {
    if (!TokenManager.instance) {
      TokenManager.instance = new TokenManager();
    }
    return TokenManager.instance;
  }

  /**
   * 设置 access token
   * @param token - 要存储的 token
   */
  async setAccessToken(token: string): Promise<void> {
    await this.storage.setItem(ACCESS_TOKEN_KEY, token);
  }

  /**
   * 获取 access token
   * @returns token 字符串或 null
   */
  async getAccessToken(): Promise<string | null> {
    return (await this.storage.getItem<string>(ACCESS_TOKEN_KEY)) || null;
  }

  /**
   * 清除 access token（退出登录时调用）
   */
  async clearAccessToken(): Promise<void> {
    await this.storage.removeItem(ACCESS_TOKEN_KEY);
  }
}

/** 导出单例实例 */
export const tokenManager = TokenManager.getInstance();
